import gql from 'graphql-tag';

export const schema = gql`
input queryVarsInput {
    page: Int
    sort: String
    sortBy: String
    searchKey: String
    artistId: ID
    status: String
}
input requestVarsInput {
  page: Int
  limit: Int
  searchKey: String
  artistId: ID
  status: String
}

input socialMediaCountInput{
  instagram: Int,
  facebook: Int,
  twitter: Int,
  spotify: Int,
  youtube: Int,
  website: Int,
}

input audienceAgeInput{
  age_13_17: Float,
  age_18_20: Float,
  age_21_24: Float,
  age_25_29: Float,
  age_30_34: Float,
  age_35_44: Float,
  age_45_64: Float,
  age_65_plus: Float,
}

input commonLabelInput{
  value: String,
  label: String,
}

input topCountryInput{
  country1: commonLabelInput,
  country2: commonLabelInput,
  country3: commonLabelInput,
  countryFollowers1: Float,
  countryFollowers2: Float,
  countryFollowers3: Float,
}

input topStateCountryInput{
  stateCountry1: commonLabelInput,
  state1: commonLabelInput,
  stateCountry2: commonLabelInput,
  state2: commonLabelInput,
  stateCountry3: commonLabelInput,
  state3: commonLabelInput,
  stateCountry4: commonLabelInput,
  state4: commonLabelInput,
  stateCountry5: commonLabelInput,
  state5: commonLabelInput,
  stateFollowers1: Float,
  stateFollowers2: Float,
  stateFollowers3: Float,
  stateFollowers4: Float,
  stateFollowers5: Float,
}

input audienceGenderInput{
  male: Float,
  female: Float,
}

input audienceEthnicityInput{
  american: Float,
  asian: Float,
  white: Float,
  hispanic: Float,
}

input engagementRateInput{
  instagramRate: Float,
  facebookRate: Float,
  twitterRate: Float,
}`;

export const REMOVE_OFFER_CLIENT = gql`
  mutation removeOfferClient($id: String!, $queryVars: queryVarsInput) {
    removeOfferClient(id: $id, queryVars: $queryVars) @client
}`;

export const REMOVE_ARTIST_OFFER = gql`
  mutation removeArtistOffer($offerId: String!, $artistId: String) {
    removeArtistOffer(offerId: $offerId, artistId: $artistId){
        message
    }
}`;

export const REQUEST_ARTIST_PARTICIPATION = gql`
mutation artistRequest($offerId: String!, $artistId: String!) {
  artistRequest(offerId: $offerId, artistId: $artistId) {
    message
  }
}`;

export const UPDATE_REQUEST_STATUS = gql`
  mutation updateRequestStatus($isRequested: Boolean, $offerId: String!, $apiData: requestVarsInput) {
    updateRequestStatus(isRequested: $isRequested, offerId: $offerId, apiData: $apiData) @client
}`;

export const INVITE_ARTIST = gql`
mutation inviteArtists($offerId: String, $inviteArtistList : [inviteArtistListInput], $additionalEmail: [String], $isEmailSendToArtist: Boolean) {
  inviteArtists(offerId: $offerId, inviteArtistList: $inviteArtistList, additionalEmail: $additionalEmail, isEmailSendToArtist: $isEmailSendToArtist) {
      message
    }
}`;

export const REMOVE_OFFER = gql`
mutation removeOffer($offerId: String!) {
  removeOffer(offerId: $offerId) {
      message
  }
}`;

export const UPDATE_ARTIST_RQUEST = gql`
mutation updateRequest($offerId: String!, $artistId: String!, $status: String!, $rejectReason: messageRejectInput) {
    updateRequest(offerId: $offerId, artistId: $artistId,  status: $status, rejectReason: $rejectReason) {
      message,
    }
}`;

export const ACCEPT_CONTRACT = gql`
  mutation acceptContract($offerId: String!, $artistId: String!) {
    acceptContract(offerId: $offerId, artistId: $artistId) {
      message
    }
}`;

export const UPDATE_PRIVATE_OFFER_REQUEST = gql`
  mutation updateArtistOffer($offerId: String!, $artistId: String!, $status: String!) {
    updateArtistOffer(offerId: $offerId, artistId: $artistId,  status: $status) {
      message,
    }
}`;

export const REMOVE_PRIVATE_OFFER_CLIENT = gql`
  mutation removePrivateOfferClient($offerId: String!, $artistId: String!, $status: String!) {
    removePrivateOfferClient(offerId: $offerId, artistId: $artistId,  status: $status) @client
}`;

export const UPDATE_CONTRACT_ACCEPTED_STATUS = gql`
  mutation updateContractAcceptedStatus($isContractAccepted: Boolean, $offerId: String!, $apiData: requestVarsInput) {
    updateContractAcceptedStatus(isContractAccepted: $isContractAccepted, offerId: $offerId, apiData: $apiData) @client
}`;

export const OFFER_NOTIFICATION_UPDATE_CLIENT = gql`
  mutation updateNotificationClient($offerId: String!, $apiData: requestVarsInput) {
    updateNotificationClient(offerId: $offerId, apiData: $apiData) @client
}`;

export const CREATE_DEMO_GRAPH = gql`
  mutation createDemographic(
    $artistId: ID, $followers: socialMediaCountInput, $audienceAge: audienceAgeInput, $authenticFollowers: Float, $topCountry: topCountryInput,
    $topState: topStateCountryInput, $audienceGender: audienceGenderInput, $audienceEthnicity: audienceEthnicityInput, $engagementRate: engagementRateInput) {
    createDemographic(
      artistId: $artistId, followers: $followers, audienceAge: $audienceAge, authenticFollowers: $authenticFollowers, topCountry: $topCountry,
      topState: $topState, audienceGender: $audienceGender, audienceEthnicity: $audienceEthnicity, engagementRate: $engagementRate) {
      message,
      hasData,
      data {
        followers{
          instagram,
          facebook,
          spotify,
          youtube,
          twitter,
          website
        }
        audienceAge{
          age_13_17,
          age_18_20,
          age_21_24,
          age_25_29,
          age_30_34,
          age_35_44,
          age_45_64,
          age_65_plus
        }
        authenticFollowers,
        topCountry{
          country1 {
            label,
            value
          },
          country2 {
            label,
            value
          },
          country3 {
            label,
            value
          },
          countryFollowers1,
          countryFollowers2,
          countryFollowers3
        },
        topState{
          stateCountry1 {
            label,
            value
          },
          state1 {
            label,
            value
          },
          stateCountry2 {
            label,
            value
          },
          state2 {
            label,
            value
          },
          stateCountry3 {
            label,
            value
          },
          state3 {
            label,
            value
          },
          stateCountry4 {
            label,
            value
          },
          state4 {
            label,
            value
          },
          stateCountry5 {
            label,
            value
          },
          state5 {
            label,
            value
          },
          stateFollowers1,
          stateFollowers2,
          stateFollowers1,
          stateFollowers2,
          stateFollowers3
        },
        audienceGender{
          male,
          female,
        },
        audienceEthnicity{
          american,
          asian,
          white,
          hispanic,
        },
        engagementRate{
          instagramRate,
          facebookRate,
          twitterRate,
        },
      }
    }
}`;

export const UPDATE_DEMO_GRAPH = gql`
  mutation updateDemographic(
    $artistId: ID, $followers: socialMediaCountInput, $audienceAge: audienceAgeInput, $authenticFollowers: Float, $topCountry: topCountryInput,
    $topState: topStateCountryInput, $audienceGender: audienceGenderInput, $audienceEthnicity: audienceEthnicityInput, $engagementRate: engagementRateInput) {
    updateDemographic(
      artistId: $artistId, followers: $followers, audienceAge: $audienceAge, authenticFollowers: $authenticFollowers, topCountry: $topCountry,
      topState: $topState, audienceGender: $audienceGender, audienceEthnicity: $audienceEthnicity, engagementRate: $engagementRate) {
      message,
      data {
        followers{
          instagram,
          facebook,
          spotify,
          youtube,
          twitter,
          website
        }
        audienceAge{
          age_13_17,
          age_18_20,
          age_21_24,
          age_25_29,
          age_30_34,
          age_35_44,
          age_45_64,
          age_65_plus
        }
        authenticFollowers,
        topCountry{
          country1 {
            label,
            value
          },
          country2 {
            label,
            value
          },
          country3 {
            label,
            value
          },
          countryFollowers1,
          countryFollowers2,
          countryFollowers3
        },
        topState{
          stateCountry1 {
            label,
            value
          },
          state1 {
            label,
            value
          },
          stateCountry2 {
            label,
            value
          },
          state2 {
            label,
            value
          },
          stateCountry3 {
            label,
            value
          },
          state3 {
            label,
            value
          },
          stateCountry4 {
            label,
            value
          },
          state4 {
            label,
            value
          },
          stateCountry5 {
            label,
            value
          },
          state5 {
            label,
            value
          },
          stateFollowers1,
          stateFollowers2,
          stateFollowers1,
          stateFollowers2,
          stateFollowers3
        },
        audienceGender{
          male,
          female,
        },
        audienceEthnicity{
          american,
          asian,
          white,
          hispanic,
        },
        engagementRate{
          instagramRate,
          facebookRate,
          twitterRate,
        },
      }
    }
}`;

export const UPLOAD_MEDIA_FOR_BETA_POST = gql`
  mutation createBetaPost($offerId: ID!, $artistId: ID!, $segmentId: ID!, $mediaUrl: String!, $imagePath: String!, $mediaType: String!) {
    createBetaPost(offerId: $offerId, artistId: $artistId, segmentId: $segmentId, mediaUrl: $mediaUrl, imagePath: $imagePath, mediaType: $mediaType) {
      message,
      data {
        media {
          _id
          url
          thumbnail
          mediaType
        }
      }
    }
}`;

export const DELETE_MEDIA_FORM_BETA_POST = gql`
  mutation removeBetaPost($offerId: ID!, $artistId: ID!, $segmentId: ID!, $mediaId: String!) {
    removeBetaPost(offerId: $offerId, artistId: $artistId, segmentId: $segmentId, mediaId: $mediaId) {
      message,
    }
}`;

export const SENT_BETA_POST_REQUEST = gql`
  mutation sentBetaPostRequest($offerId: ID!, $artistId: ID, $segmentId: ID!, $betaPostInfo: String!) {
    sentBetaPostRequest(offerId: $offerId, artistId: $artistId, segmentId: $segmentId, betaPostInfo: $betaPostInfo) {
      message,
    }
}`;

export const UPDATE_OFFER_PRICE = gql`
  mutation offerPriceUpdate($offerId: ID!, $artistId: ID!, $basePrice: Int!) {
    offerPriceUpdate(offerId: $offerId, artistId: $artistId, basePrice: $basePrice) {
      message
    }
}`;

export const UPDATE_BETA_POST_REQUEST = gql`
  mutation updateBetaPostRequest($offerId: ID!, $segmentId: ID!, $artistId: ID, $status: String!, $rejectReason: messageRejectInput) {
    updateBetaPostRequest(offerId: $offerId, segmentId: $segmentId, artistId: $artistId, status: $status, rejectReason: $rejectReason) {
      message
    }
}`;

export const PUBLISH_BETA_POST_REQUEST = gql`
  mutation publishBetaPost($offerId: ID!, $artistId: ID!, $segmentId: ID!, $instagramUrl: String,
    $facebookUrl: String, $twitterUrl: String, $youtubeUrl: String, $spotifyUrl: String) {
    publishBetaPost(offerId: $offerId, artistId: $artistId, segmentId: $segmentId, instagramUrl: $instagramUrl
      facebookUrl: $facebookUrl, twitterUrl: $twitterUrl, youtubeUrl: $youtubeUrl, spotifyUrl: $spotifyUrl) {
      message,
    }
}`;

export const REMOVE_RECENT_ACTIVITY = gql`
  mutation removeRecentActivity($activityId: String!) {
    removeRecentActivity(activityId: $activityId) {
      message,
    }
}`;
